import { configureStore } from '@reduxjs/toolkit';
import { devToolOption } from '../services/httpService';
import api from './middleware/api';
import reducer from './Reducers';


const store = configureStore({
    reducer,
    middleware: [api],
    devTools: devToolOption
})

export default store;